import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
// import Box from '@mui/material/Box';

import Main from 'layouts/Main';
import Container from 'components/Container';
import { PageReferences, Hero } from './components';

import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})

analytics.page()

const Home = () => {
  const theme = useTheme();
  return (
    <Main>
     <Container maxWidth={0.78}  >
          <Hero />
          </Container>
     
    </Main>
  );
};

export default Home;
